import React from 'react';
import { PRIVACY_POLICY_URL } from '../constants';

import {
  Box,
  Flex,
  Heading3,
  Link,
  Paragraph,
  thc,
} from '@flightstats/airframe-react';

import { CiriumWrapperWithHeader } from '../components/cirium/CiriumWrapperWithHeader';

const PageContainer = thc(Flex, {
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  margin: '0 auto',
  maxWidth: '1024px',
});

const TravelerTerms: React.FC = () => (
  <CiriumWrapperWithHeader appName="Cirium Trip Alerts">
    <PageContainer>
      <Box>
        <Heading3 spacing={3}>Terms and Conditions</Heading3>
        <Paragraph>
          1. Cirium Trip Alerts is a service that sends message alerts relevant
          to your air travel itinerary. You will receive messages notifying you
          of events such as flight delays, gate changes, and potential missed
          connections.
        </Paragraph>
        <Paragraph>
          2. You can cancel the SMS service at any time. Just text
          &quot;STOP&quot; to the short code. After you send the SMS message
          &quot;STOP&quot; to us, we will send you an SMS message to confirm
          that you have been unsubscribed. After this, you will no longer
          receive SMS messages from us. If you want to join again, just enable
          Text to Cell in your Traveler Profile as you did the first time and we
          will start sending SMS messages to you again.
        </Paragraph>
        <Paragraph>
          3. If you are experiencing issues with the messaging program you can
          reply with the keyword HELP for more assistance, or you can get help
          directly at{' '}
          <Link href="mailto:helpdesk@cirium.com">helpdesk@cirium.com</Link>.
        </Paragraph>
        <Paragraph>
          4. Carriers are not liable for delayed or undelivered messages
        </Paragraph>
        <Paragraph>
          5. As always, message and data rates may apply for any messages sent
          to you from us and to us from you. You will receive messages only when
          a significant change happens related to your travel itinerary. If you
          have any questions about your text plan or data plan, it is best to
          contact your wireless provider.
        </Paragraph>
        <Paragraph>
          6. If you have any questions regarding privacy, please read our{' '}
          <Link href={PRIVACY_POLICY_URL}>privacy policy</Link>
        </Paragraph>
      </Box>
    </PageContainer>
  </CiriumWrapperWithHeader>
);

export default TravelerTerms;